import { FC } from 'react';
import { useIntl } from 'react-intl';
import { CalculatorHeading } from '@components/common/CalculatorHeading/CalculatorHeading';
import { CalculatorText } from '@components/common/CalculatorText/CalculatorText';
import { FormSelect } from '@components/common/FormSelect/FormSelect';
import { CalculatorDoubleSelectProps } from './types';

export const CalculatorDoubleSelect: FC<CalculatorDoubleSelectProps> = ({
  names,
  textKey,
  titleKey,
  rules,
  className,
  options,
  selectPropses,
  placeholdersKeys,
  shouldShowAdornment,
  isDisabled,
}) => {
  const intl = useIntl();

  return (
    <div className={className}>
      <CalculatorHeading labelKey={titleKey} />
      <CalculatorText labelKey={textKey} />
      <div className={'mt-2 flex'}>
        <div className={'xs:mr-1 w-1/2 md:mr-4'}>
          <FormSelect
            name={names[0]}
            rules={rules}
            options={options[0]}
            shouldShowAdornment={shouldShowAdornment?.[0] || false}
            selectProps={selectPropses?.[0]}
            selectInputProps={{
              placeholder: intl.formatMessage({ id: placeholdersKeys[0] }),
            }}
            isDisabled={isDisabled?.[0] || false}
          />
        </div>
        <div className={'xs:ml-1 w-1/2 md:ml-4'}>
          <FormSelect
            name={names[1]}
            rules={rules}
            options={options[1]}
            shouldShowAdornment={shouldShowAdornment?.[1] || false}
            selectProps={selectPropses?.[1]}
            selectInputProps={{
              placeholder: intl.formatMessage({ id: placeholdersKeys[1] }),
            }}
            isDisabled={isDisabled?.[1] || false}
          />
        </div>
      </div>
    </div>
  );
};
